(function () {
  var WORKER_BASE = 'https://iso-number-lock.isobasketball.workers.dev';
  var FATAL_ERROR_TEXT =
    "Sorry, we can't load this jersey's number list right now. Please email help@isobasketball.shop and we'll sort it for you.";
  var TAKEN_ERROR_TEXT = 'That number was just taken. Please pick another.';
  var GENERIC_LOCK_ERROR_TEXT = "Couldn't reserve that number. Please try again.";

  function init(form) {
    var club = form.dataset.clubHandle;
    var teamSelect = form.querySelector('[data-iso-nl-team]');
    var numberSelect = form.querySelector('[data-iso-nl-number]');
    var teamIdInput = form.querySelector('[data-iso-nl-team-id]');
    var submitBtn = form.querySelector('[data-iso-nl-submit]');
    var submitLabel = submitBtn.querySelector('span');
    var originalSubmitLabel = submitLabel.textContent;
    var firstInput = form.querySelector('input[name="properties[Player First Name]"]');
    var lastInput = form.querySelector('input[name="properties[Player Last Name]"]');
    var dobInput = form.querySelector('input[name="properties[Player DOB]"]');
    var errorBlock = form.parentNode.querySelector('[data-iso-nl-error]');
    var errorPara = errorBlock ? errorBlock.querySelector('p') : null;
    var lockIdInput = null;

    function setErrorText(text) {
      if (errorPara) errorPara.textContent = text;
    }

    function showFatalError() {
      setErrorText(FATAL_ERROR_TEXT);
      form.hidden = true;
      if (errorBlock) errorBlock.hidden = false;
    }

    function showInlineError(text) {
      setErrorText(text);
      if (errorBlock) errorBlock.hidden = false;
    }

    function clearInlineError() {
      if (errorBlock) errorBlock.hidden = true;
      setErrorText(FATAL_ERROR_TEXT);
    }

    function setBusy(busy) {
      submitBtn.disabled = busy;
      submitLabel.textContent = busy ? 'Locking number…' : originalSubmitLabel;
    }

    function loadTeams() {
      fetch(WORKER_BASE + '/api/clubs/' + encodeURIComponent(club) + '/teams')
        .then(function (r) {
          if (!r.ok) throw new Error('teams http ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var teams = (data && data.teams) || [];
          if (!teams.length) throw new Error('no teams');
          teamSelect.innerHTML = '<option value="">Select a team…</option>';
          teams.forEach(function (t) {
            var opt = document.createElement('option');
            // Submit display_name as the human-readable Team property; the
            // numeric id rides along separately in the hidden _team_id input.
            opt.value = t.display_name;
            opt.dataset.teamId = t.id;
            opt.textContent = t.display_name;
            teamSelect.appendChild(opt);
          });
          teamSelect.disabled = false;
        })
        .catch(showFatalError);
    }

    function loadNumbers(teamId) {
      numberSelect.disabled = true;
      numberSelect.innerHTML = '<option value="">Loading numbers…</option>';
      fetch(
        WORKER_BASE +
          '/api/clubs/' +
          encodeURIComponent(club) +
          '/teams/' +
          encodeURIComponent(teamId) +
          '/available-numbers'
      )
        .then(function (r) {
          if (!r.ok) throw new Error('numbers http ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var numbers = (data && data.available) || [];
          if (!numbers.length) {
            numberSelect.innerHTML = '<option value="">No numbers available</option>';
            numberSelect.disabled = true;
            return;
          }
          numberSelect.innerHTML = '<option value="">Select a number…</option>';
          numbers.forEach(function (n) {
            var opt = document.createElement('option');
            opt.value = n;
            opt.textContent = n;
            numberSelect.appendChild(opt);
          });
          numberSelect.disabled = false;
        })
        .catch(showFatalError);
    }

    teamSelect.addEventListener('change', function () {
      var picked = teamSelect.options[teamSelect.selectedIndex];
      var teamId = picked && picked.dataset ? picked.dataset.teamId || '' : '';
      teamIdInput.value = teamId;
      if (teamId) {
        loadNumbers(teamId);
      } else {
        numberSelect.innerHTML = '<option value="">Pick a team first</option>';
        numberSelect.disabled = true;
      }
    });

    form.addEventListener('submit', function (e) {
      // Native HTML5 `required` validation runs before this handler fires, so by
      // the time we're here the four required fields are filled. DOB is optional
      // and may be ''; the worker normalises that to a SQL NULL. Intercept to
      // soft-lock the number first, then submit through to /cart/add only on
      // success.
      e.preventDefault();
      clearInlineError();
      setBusy(true);

      var body = {
        team_id: parseInt(teamIdInput.value, 10),
        player_name: (firstInput.value + ' ' + lastInput.value).trim().replace(/\s+/g, ' '),
        dob: dobInput.value,
        number: parseInt(numberSelect.value, 10),
      };

      fetch(WORKER_BASE + '/api/clubs/' + encodeURIComponent(club) + '/lock', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) {
          return r.json().then(
            function (data) { return { ok: r.ok, status: r.status, data: data }; },
            function () { return { ok: r.ok, status: r.status, data: null }; }
          );
        })
        .then(function (res) {
          if (res.ok && res.data && res.data.lock_id != null) {
            if (!lockIdInput) {
              lockIdInput = document.createElement('input');
              lockIdInput.type = 'hidden';
              lockIdInput.name = 'properties[_lock_id]';
              form.appendChild(lockIdInput);
            }
            lockIdInput.value = res.data.lock_id;
            setBusy(false);
            form.submit(); // bypasses this handler — no recursion.
            return;
          }

          if (res.status === 409) {
            setBusy(false);
            showInlineError(TAKEN_ERROR_TEXT);
            numberSelect.value = '';
            var teamId = teamIdInput.value;
            if (teamId) loadNumbers(teamId);
            return;
          }

          setBusy(false);
          showInlineError(GENERIC_LOCK_ERROR_TEXT);
        })
        .catch(function () {
          setBusy(false);
          showInlineError(GENERIC_LOCK_ERROR_TEXT);
        });
    });

    loadTeams();
  }

  function ready() {
    document.querySelectorAll('[data-iso-nl-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
